import React from "react";
import Github from "../Components/Github";
import LinkedIn from "../Components/LinkedIn";

export default function Contact() {

    const [formStatus, setFormStatus] = React.useState("");

    const handleSubmit = async (submitEvent) => {
        submitEvent.preventDefault();
        setFormStatus("Sending...");
        const formElement = submitEvent.currentTarget;
        const formData = new FormData(formElement);
        formData.append("access_key", "880608e2-3d16-4cef-9377-0e3b434a4003");

        try {
            const response = await fetch("https://api.web3forms.com/submit", {
                method: "POST",
                body: formData,
            });
            const submissionResult = await response.json();

            if (submissionResult.success) {
                setFormStatus("Message sent successfully.");
                formElement.reset();
            } else {
                setFormStatus(submissionResult.message || "Unable to send your message. Please try again.");
            }
        } catch {
            setFormStatus("Unable to send your message. Check your connection and try again.");
        }
    };

    return (
        <div>
            <section className="contact">
                <form onSubmit={handleSubmit}>
                    <h2>Get in touch</h2>
                    <div className="input-box">
                        <label htmlFor="contact-name">Full name</label>
                        <input id="contact-name" type="text" className="field" placeholder="Enter your name" name="name" required/>
                    </div>
                    <div className="input-box">
                        <label htmlFor="contact-email">Email address</label>
                        <input id="contact-email" type="email" className="field" placeholder="Enter your email" name="email" required/>
                    </div>
                    <div className="input-box">
                        <label htmlFor="contact-message">Your message</label>
                        <textarea id="contact-message" name="message" className="field mess" placeholder="Enter your message"
                                  required></textarea>
                    </div>
                    <button type="submit">Send Message</button>
                    {formStatus && <p className="formStatus" role="status">{formStatus}</p>}
                </form>
            </section>
            <div className="linksTile">
                <Github/>
                <LinkedIn/>
            </div>
        </div>
    )
}
